import { Button } from "@chakra-ui/react";
import styled from "@emotion/styled";
import React from "react";
import { colors } from "../../../constants/design.constants";

export const ButtonCustom: React.FC<{
  children: any;
  onClick?: () => void;
  size?: "sm" | "md" | "lg";
  rounded?: boolean;
  secondary?: boolean;
  type?: "button" | "submit" | "reset" | undefined;
  disabled?: boolean;
  neutral?: boolean;
  danger?: boolean;
  hidden?: boolean;
  style?: any;
}> = (props) => {
  const getWidth = () => {
    switch (props.size) {
      case "sm":
        return "80px";
      case "md":
        return "120px";
      case "lg":
        return "160px";
      default:
        return "hug";
    }
  };

  let properties = {
    hidden: props.hidden,
    isDisabled: props.disabled,
    type: props.type,
    variant: "container",
    onClick: props.onClick,
    width: getWidth(),
    borderRadius: "2px",
    style: { ...props.style },
  } as any;

  if (props.danger) {
    return <DangerButton {...properties}>{props.children}</DangerButton>;
  }

  if (props.neutral) {
    return <NeutralButton {...properties}>{props.children}</NeutralButton>;
  }

  if (props.secondary) {
    return <SecondaryButton {...properties}>{props.children}</SecondaryButton>;
  }

  return <ButtonComponent {...properties}>{props.children}</ButtonComponent>;
};

const StyledButton = styled(Button)({
  boxShadow: "none !important",
  padding: "8px 14px",
  fontSize: "13px",
  fontWeight: 500,
  border: "none",
  letterSpacing: "0.04em",
  textTransform: "uppercase",
  borderRadius: "2px",
});

const ButtonComponent = styled(StyledButton)({
  color: colors.void,
  backgroundColor: colors.signal,
  "&:hover": {
    backgroundColor: "#7AC8DE",
  },
});

const SecondaryButton = styled(StyledButton)({
  backgroundColor: colors.signalMuted,
  color: colors.signal,
  border: `1px solid ${colors.signalDim}`,
  "&:hover": {
    backgroundColor: "rgba(94, 184, 212, 0.25)",
  },
});

const NeutralButton = styled(StyledButton)({
  backgroundColor: "transparent",
  border: `1px solid ${colors.border}`,
  color: colors.textPrimary,
  "&:hover": {
    borderColor: colors.signal,
    color: colors.signal,
  },
});

const DangerButton = styled(StyledButton)({
  backgroundColor: colors.dangerMuted,
  border: `1px solid ${colors.danger}44`,
  color: colors.danger,
});
